<template>
  <!-- 遮罩层 -->
  <div class="mask" v-show="isCaptha">
    <div class="slideContainer">
      <div class="slideContainer_tips">
        <div :class="colour">{{ textTips }}</div>
        <van-icon
          class="el-icon-close"
          style="font-size: 25px"
          name="cross"
          @click="isCaptha = false"
        />
      </div>
      <div
        id="slideVerify"
        class="slide-verify"
        :style="widthlable"
        onselectstart="return false;"
      >
        <canvas ref="canvas" :width="w" :height="h" />

        <canvas ref="block" class="slide-verify-block" :width="w" :height="h" />
        <!-- <div class="slide-verify-refresh-icon el-icon-refresh" @click="refresh" /> -->
        <van-icon
          class="slide-verify-refresh-icon el-icon-refresh"
          style="transform: rotate(180deg)"
          @click="refresh"
          name="replay"
        />
        <!-- @click="refresh" -->
        <!-- <div class="slide-verify-info" :class="{ fail: fail, show: showInfo }" >{{ infoText }}</div> -->
        <div
          class="slide-verify-slider"
          :style="widthlable"
          :class="{
            'container-active': containerActive,
            'container-success': containerSuccess,
            'container-fail': containerFail,
          }"
        >
          <div class="slide-verify-slider-mask" :style="{ width: sliderMaskWidth }">
            <!-- slider -->
            <div
              class="slide-verify-slider-mask-item"
              :style="{ left: sliderLeft }"
              @mousedown="sliderDown"
              @touchstart.prevent="touchStartEvent"
              @touchmove.prevent="touchMoveEvent"
              @touchend.prevent="touchEndEvent"
            >
              <div class="slide-gan"></div>
              <div class="slide-gan"></div>
              <div class="slide-gan"></div>
              <!-- <div class="slide-verify-slider-mask-item-icon el-icon-s-unfold" /> -->
            </div>
          </div>
          <span class="slide-verify-slider-text">{{ sliderText }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { reactive, toRefs, ref, onMounted } from "vue";
function sum(x, y) {
  return x + y;
}

function square(x) {
  return x * x;
}
export default {
  name: "SlideVerify",
  props: {
    l: {
      type: Number,
      default: 42,
    },
    // block radius
    r: {
      type: Number,
      default: 10,
    },
    // canvas width
    w: {
      // 背景图宽
      type: [Number, String],
      default: 350,
    },
    // canvas height
    h: {
      // 背景图高
      type: [Number, String],
      default: 200,
    },
    // canvas width
    sw: {
      // 小图宽
      type: [Number, String],
      default: 50,
    },
    // canvas height
    sh: {
      type: [Number, String],
      default: 50,
    },
    // block_x: {
    //   type: Number,
    //   default: 155
    // },
    blocky: {
      // 小图初始的垂直距离
      type: [Number, String],
      default: 20,
    },
    sliderText: {
      type: String,
      default: "", //Slide filled right
    },
    imgurl: {
      // 大图地址
      type: String,
      default: "",
    },
    miniimgurl: {
      // 小图地址
      type: String,
      default: "",
    },
    fresh: {
      type: Boolean,
      default: false,
    },
    colour: {
      // 提示颜色
      type: String,
      default: "",
    },
    textTips: {
      // 小图地址
      type: String,
      default: "",
    },
  },
  setup(props, context) {
    const block = ref();
    const canvas = ref();
    const state = reactive({
      containerActive: false, // container active class
      containerSuccess: false, // container success class
      containerFail: false, // container fail class
      canvasCtx: null,
      blockCtx: null,
      block: null,
      canvasStr: null,
      // block_x: undefined, // container random position
      // blocky: undefined,
      L: props.l + props.r * 2 + 3, // block real lenght
      img: undefined,
      originX: undefined,
      originY: undefined,
      isMouseDown: false,
      trail: [],
      widthlable: "",
      sliderLeft: 0, // block right offset
      sliderMaskWidth: 0, // mask width
      dialogVisible: false,
      infoText: "验证成功",
      fail: false,
      showInfo: false,
      isCaptha: false,
    });
    const init = () => {
      initDom();
      bindEvents();
      state.widthlable = "width:" + props.w + "px;";
    };
    const initDom = () => {
      state.block = block.value;
      state.canvasStr = canvas.value;

      state.canvasCtx = state.canvasStr.getContext("2d");
      state.blockCtx = state.block.getContext("2d");
      initImg();
    };
    const initImg = (h) => {
      var that = state;
      const img = document.createElement("img");
      img.onload = onload;
      img.onerror = () => {
        img.src = props.imgurl;
      };
      img.src = props.imgurl;
      img.onload = function () {
        that.canvasCtx.drawImage(img, 0, 0, props.w, props.h);
      };

      state.img = img;
      const img1 = document.createElement("img");
      var blockCtx = that.blockCtx;
      var blocky = h || props.blocky;
      if (blocky === 0) {
        return;
      }
      img1.onerror = () => {
        img1.src = props.miniimgurl;
      };
      img1.src = props.miniimgurl;
      img1.onload = function () {
        // blockCtx.drawImage(img1, 0, blocky, props.sw, props.sh)
        blockCtx.drawImage(img1, 0, blocky);
      };
      // console.log(777, h)
    };
    // 刷新
    const refresh = () => {
      context.emit("refresh");
    };
    const sliderDown = (event) => {
      state.originX = event.clientX;
      state.originY = event.clientY;
      state.isMouseDown = true;
    };
    const touchStartEvent = (e) => {
      state.originX = e.changedTouches[0].pageX;
      state.originY = e.changedTouches[0].pageY;
      state.isMouseDown = true;
    };
    const bindEvents = () => {
      document.addEventListener("mousemove", (e) => {
        if (!state.isMouseDown) return false;
        const moveX = e.clientX - state.originX;
        const moveY = e.clientY - state.originY;
        if (moveX < 0 || moveX + 38 >= props.w) return false;
        state.sliderLeft = moveX + "px";
        // const blockLeft = ((props.w - 40 - 20) / (props.w - 40)) * moveX
        const blockLeft = ((props.w - 40 - 0) / (props.w - 40)) * moveX;
        state.block.style.left = blockLeft + "px";
        state.containerActive = true; // add active
        state.sliderMaskWidth = moveX + "px";
        state.trail.push(moveY);
      });
      document.addEventListener("mouseup", (e) => {
        if (!state.isMouseDown) return false;
        state.isMouseDown = false;
        if (e.clientX === state.originX) return false;
        state.containerActive = false; // remove active
        verify();
      });
    };
    const touchMoveEvent = (e) => {
      if (!state.isMouseDown) return false;
      const moveX = e.changedTouches[0].pageX - state.originX;
      const moveY = e.changedTouches[0].pageY - state.originY;
      if (moveX < 0 || moveX + 38 >= props.w) return false;
      state.sliderLeft = moveX + "px";
      // const blockLeft = ((props.w - 40 - 20) / (props.w - 40)) * moveX
      const blockLeft = ((props.w - 40 - 0) / (props.w - 40)) * moveX;
      state.block.style.left = blockLeft + "px";

      state.containerActive = true;
      state.sliderMaskWidth = moveX + "px";
      state.trail.push(moveY);
    };
    const touchEndEvent = (e) => {
      if (!state.isMouseDown) return false;
      state.isMouseDown = false;
      if (e.changedTouches[0].pageX === state.originX) return false;
      state.containerActive = false;
      verify();
    };
    const verify = () => {
      const arr = state.trail; // drag y move distance
      const average = arr.reduce(sum) / arr.length; // average
      const deviations = arr.map((x) => x - average); // deviation array
      const stddev = Math.sqrt(deviations.map(square).reduce(sum) / arr.length); // standard deviation
      const left = parseInt(state.block.style.left);
      context.emit("success", left, stddev);
    };
    const reset = (h) => {
      state.containerActive = false;
      state.containerSuccess = false;
      state.containerFail = false;
      state.sliderLeft = 0;
      state.block.style.left = 0;
      state.sliderMaskWidth = 0;
      state.canvasCtx.clearRect(0, 0, props.w, props.h);
      state.blockCtx.clearRect(0, 0, props.w, props.h);
      state.fail = false;
      state.showInfo = false;
      state.containerFail = false;
      state.containerSuccess = false;
      initImg(h);
    };
    const handleFail = () => {
      state.fail = true;
      state.showInfo = true;
      state.infoText = "验证失败";
      state.containerFail = true;
      // console.log(6666)
      setTimeout(() => {
        state.block.style.left = 0;
        state.sliderMaskWidth = 0;
        state.sliderLeft = 0;
        state.fail = false;
        state.showInfo = false;
        state.containerFail = false;
        context.emit("fail", 2);
      }, 500);
    };
    const handleSuccess = () => {
      // console.log(777)
      state.showInfo = true;
      state.infoText = "验证成功";
      state.containerSuccess = true;
      setTimeout(() => {
        state.block.style.left = 0;
        state.sliderMaskWidth = 0;
        state.sliderLeft = 0;
        state.fail = false;
        state.showInfo = false;
        state.containerSuccess = false;
        context.emit("fail", 1);
      }, 1000);
    };
    onMounted(() => {
      init();
    });
    return {
      ...toRefs(state),
      ...props,
      touchStartEvent,
      handleSuccess,
      handleFail,
      reset,
      touchEndEvent,
      touchMoveEvent,
      bindEvents,
      sliderDown,
      refresh,
      block,
      canvas,
    };
  },
};
</script>

<style scoped lang="less">
.slide-verify {
  position: relative;
  width: 310px;
  /* overflow: hidden; */
}

.slide-verify-block {
  position: absolute;
  left: 0;
  top: 0;
}

.slide-verify-refresh-icon {
  position: absolute;
  right: 0;
  top: 0;
  width: 34px;
  height: 34px;
  cursor: pointer;
  content: "刷新";
  font-size: 22px;
  line-height: 34px;
  text-align: center;
  font-weight: bold;
  color: #ffffff;
  /* background: url("../../assets/move/icon_light.png") 0 -437px; */
  background-size: 34px 471px;
}

.slide-verify-refresh-icon:hover {
  transform: rotate(180deg);
  transition: all 0.2s ease-in-out;
}

.slide-verify-slider {
  position: relative;
  text-align: center;
  width: 310px;
  height: 20px;
  line-height: 20px;
  margin-top: 15px;
  background: #ccc;
  color: #45494c;
  border-radius: 20px;
  /* border: 1px solid #e4e7eb; */
}

.slide-verify-slider-mask {
  position: absolute;
  left: 0;
  top: 0;
  height: 20px;
  /* border: 0 solid #1991fa; */
  /* background: #d1e9fe; */
}

/* .slide-verify-info {
    position: absolute;
    top: 170px;
    left: 0;
    height: 30px;
    width: 350px;
    color: #fff;
    text-align: center;
    line-height: 30px;
    background-color: #52ccba;
    opacity: 0;
} */

/* .slide-verify-info.fail {
    background-color: #f57a7a;
} */

.slide-verify-info.show {
  animation: hide 1s ease;
}

@keyframes hide {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 0.9;
  }
}

.slide-verify-slider-mask-item {
  position: absolute;
  /* top: 0; */
  top: -5px !important;
  left: 0;
  width: 30px;
  height: 30px !important;
  /* background: #fff; */
  background-color: var(--main-bg-color) !important;
  border: none !important;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  transition: background 0.2s linear;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}

.slide-verify-slider-mask-item:hover {
  background: #1991fa;
}

.slide-verify-slider-mask-item:hover .slide-verify-slider-mask-item-icon {
  background-position: 0 -13px;
}

.slide-verify-slider-mask-item-icon {
  position: absolute;
  top: 9px;
  left: 7px;
  width: 14px;
  height: 12px;
  content: "法币";
  font-size: 22px;
  color: #ddd;
  /* text-align: center;
      line-height: 12px; */
  /* background: url("../../assets/move/icon_light.png") 0 -26px; */
  /* background-size: 34px 471px; */
}

.container-active .slide-verify-slider-mask-item {
  height: 38px;
  top: -1px;
  border: 1px solid #1991fa;
}

.container-active .slide-verify-slider-mask {
  height: 38px;
  border-width: 1px;
}

/* .container-success .slide-verify-slider-mask-item {
    height: 38px;
    top: -1px;
    border: 1px solid #52ccba;
    background-color: #52ccba !important;
}

.container-success .slide-verify-slider-mask {
    height: 38px;
    border: 1px solid #52ccba;
    background-color: #d2f4ef;
} */

.container-success .slide-verify-slider-mask-item-icon {
  background-position: 0 0 !important;
}

/*
.container-fail .slide-verify-slider-mask-item {
    height: 38px;
    top: -1px;
    border: 1px solid #f57a7a;
    background-color: #201c1c !important;
}

.container-fail .slide-verify-slider-mask {
    height: 38px;
    border: 1px solid #f57a7a;
    background-color: #fce1e1;
} */

.container-fail .slide-verify-slider-mask-item-icon {
  top: 14px;
  background-position: 0 -82px !important;
}

.container-active .slide-verify-slider-text,
.container-success .slide-verify-slider-text,
.container-fail .slide-verify-slider-text {
  display: none;
}

.slide-gan {
  width: 1px;
  height: 10px;
  background-color: #ffffff;
  margin-right: 5px;
}

.slide-gan:last-child {
  margin: 0px;
}

.mask {
  position: fixed;
  left: 0%;
  top: 0%;
  width: 100%;
  height: 100%;
  z-index: 1000000;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.5);
}

.mask .slideContainer {
  position: absolute;
  left: 50%;
  top: 50%;
  background-color: rgb(255, 255, 255);
  transform: translate(-50%, -50%);
  padding: 15px;
}

.mask .slideContainer_tips {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
}

.mask_red {
  color: red;
}

.mask_ls {
  color: #13ce66;
}
</style>
